import seoWidget from './seoWidget.js';
import youtubeVideo from './youtubeVideo.js';
import customSignup from './customSignup.js';

export default function seoSection() {
  seoWidget();

  $(globalThis).on('load', function () {
    youtubeVideo();
  });

  customSignup();
}
